// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetWorkItemStatusesRequestModel from '../../model/get-work-item-statuses-request-model';
import GetWorkItemStatusesRequestDTO from '../dto/get-work-item-statuses-request-dto';
import dtoSchema from '../schemas/get-work-item-statuses-request-schema';

export default abstract class GetWorkItemStatusesRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetWorkItemStatusesRequestDTO>) {
    super();
    if (data) {
      this.projectId = data.projectId;
    }
  }
  /**
  * @type {uuid}
  */
  projectId?: string;

  static toModel(dto: DeepPartial<GetWorkItemStatusesRequestDTO>): GetWorkItemStatusesRequestModel;
  static toModel(dto: DeepPartial<GetWorkItemStatusesRequestDTO> | undefined | null): GetWorkItemStatusesRequestModel | undefined;
  static toModel(dto: DeepPartial<GetWorkItemStatusesRequestDTO> | undefined | null): GetWorkItemStatusesRequestModel | undefined {
    return dto ? new GetWorkItemStatusesRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetWorkItemStatusesRequestModel> | GetWorkItemStatusesRequestModel): GetWorkItemStatusesRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      projectId: unwrapped.projectId,
    } as GetWorkItemStatusesRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetWorkItemStatusesRequestModel, can not map to GetWorkItemStatusesRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
